import { type RouteConfig } from 'vue-router'

export const SwaggerRouter: RouteConfig[] = [
  {
    path: '/swagger',
    component: async () => import('./Swagger.vue'),
  },
]
